// frontend/src/config/ecosystemApps.js
//
// Other apps of the same organisation that this ERP can launch (with SSO), and
// the rule for who SEES each app. Shared by the dashboard launchpad and the
// sidebar entry (Layout.js) so the two can never disagree. Visibility only —
// the backend still gates every SSO mint with hasEcosystemAccess().
//
// Craft ships with none. Each entry: { id, name, domain, color, bg, desc,
// roles?: [...], emails?: [...], ecosystemGate?: true, external?: true }.
export const ECOSYSTEM_APPS = [];

// Founders see all apps. ecosystemGate apps require the user's ecosystemApps
// array (from /auth/me) to include the app id. Otherwise an app with a roles or
// emails whitelist is visible on a match, and an app with neither is visible
// to everyone.
export function canSeeEcosystemApp(app, user) {
  if (!app) return false;
  if (user?.role === 'founder') return true;
  if (app.ecosystemGate) return (user?.ecosystemApps || []).includes(app.id);
  const hasRestrictions = app.roles || app.emails;
  if (!hasRestrictions) return true;
  const roleMatch = !!(app.roles && app.roles.includes(user?.role));
  const emailMatch = !!(app.emails && app.emails.includes(user?.email?.toLowerCase()));
  return roleMatch || emailMatch;
}

// Signed-out users never see the AERIS entry (the rule above alone would say
// "no" anyway — aeris has an emails whitelist — this just makes it explicit).
export const canSeeAeris = (user) =>
  !!user && canSeeEcosystemApp(ECOSYSTEM_APPS.find(a => a.id === 'aeris'), user);
